import { useEffect, type CSSProperties } from 'react';
import { useNavigate } from 'react-router';
import { EarnedBadgeArt } from '@/components/EarnedBadge/EarnedBadgeArt';
import { EARNED_BADGE_TYPES } from '@/components/EarnedBadge/earnedBadgeRegistry';
import { badgeDetailPath } from '@/pages/Badges/badgeRoutes';
import { useUser } from '@/hooks/user/useUser';
import { toast } from '@/lib/toast';
import { useGetUnseenEarnedBadgesQuery, useMarkEarnedBadgesSeenMutation } from '@/services/ApiService';

export const earnedBadgeToastId = (badgeId: string): string => `badge-earned-${badgeId}`;

export const useEarnedBadgeToasts = (): void => {
    const navigate = useNavigate();
    const { user } = useUser();
    const { data: unseen } = useGetUnseenEarnedBadgesQuery(undefined, { skip: !user });
    const [markSeen] = useMarkEarnedBadgesSeenMutation();

    useEffect(() => {
        if (!unseen?.length) return;

        unseen.forEach((badge) => {
            toast.success('You’ve Earned a Badge!', {
                id: earnedBadgeToastId(badge.id),
                icon: (
                    <span
                        className="gz-toast-badge-sheen"
                        style={{
                            '--gz-badge-art': `url("${EARNED_BADGE_TYPES[badge.type].art}")`,
                            '--gz-badge-sheen-angle': EARNED_BADGE_TYPES[badge.type].sheenAngle,
                        } as CSSProperties}
                    >
                        <EarnedBadgeArt type={badge.type} className="w-10" />
                    </span>
                ),
                classNames: { icon: 'gz-toast-badge-icon' },
                action: {
                    label: 'See Badge',
                    onClick: () => navigate(badgeDetailPath(badge.id)),
                },
                dataTrackActionClick: 'Badges Earned Toast See Badge Clicked',
                dataTrackActionButtonName: 'toast-badge-earned-see-badge',
                dataTrackLocation: 'badges',
            });
        });
        void markSeen(unseen.map(badge => badge.id));
    }, [unseen, markSeen, navigate]);
};
